import styled from "styled-components";

export const RadioContainer = styled.div`
    display: flex;
    justify-content: space-between;
`